// extracted by mini-css-extract-plugin
export var content = "_bv-3";
export var list = "_bv-4";
export var settingsContent = "_bv-7";
export var settingsPanel = "_bv-8";
export var state = "_bv-6";
export var triggerBadge = "_bv-2";
export var triggerButton = "_bv-1";
export var triggerShell = "_bv-0";
export var unreadDot = "_bv-5";